import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const removeStore: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.REMOVE_STORE_ACTIONS.REQUESTED),
    switchMap(({ payload: { storeId } }) =>
      storeApi.removeStoreById(storeId).pipe(
        switchMap(() => of(actions.removeStoreSucceeded(storeId))),
        catchError(error => of(actions.removeStoreFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/removeStore.ts